export enum ProductActionType {
  SET_PRODUCT_PLANS = 'SET_PRODUCT_PLANS',
  SET_PRODUCT_PLAN_LOADED = 'SET_PRODUCT_PLAN_LOADED',
  SET_FILTERED_PRODUCT_PLANS = 'SET_FILTERED_PRODUCT_PLANS',
  SET_SELECTED_PRODUCT = 'SET_SELECTED_PRODUCT',
  SET_PRECONTRACTUAL_INFO = 'SET_PRECONTRACTUAL_INFO',
  SET_PAY_PAGE_HANDLES = 'SET_PAY_PAGE_HANDLES',
  SET_CREDIT_ACCEPTED = 'SET_CREDIT_ACCEPTED',
  SET_PAYPAL_TOKEN = 'SET_PAYPAL_TOKEN',
  SET_PAYPAL_NOUNCE = 'SET_PAYPAL_NOUNCE',
  SET_CONTRACT = 'SET_CONTRACT',
  SET_RECORD_OF_ADVICE_URL = 'SET_RECORD_OF_ADVICE_URL',
  SET_PRECI_ITEMS = 'SET_PRECI_ITEMS',
}
